/**
 * Primitivas de rango semiabierto `[inicio, fin)`.
 *
 * Deben coincidir exactamente con la semantica de `tstzrange` en Postgres:
 * el constraint de exclusion de §4.3 es la verdad, esto es su espejo en cliente.
 * Si estas funciones y la base discrepan, el motor promete slots que la base rechaza.
 */
export function esRangoValido(r) {
    return r.inicio.getTime() < r.fin.getTime();
}
/** `[14:00, 15:00)` y `[15:00, 16:00)` NO se solapan. */
export function seSolapan(a, b) {
    return a.inicio.getTime() < b.fin.getTime() && b.inicio.getTime() < a.fin.getTime();
}
/** `contenedor` cubre integramente a `r`. */
export function contiene(contenedor, r) {
    return (contenedor.inicio.getTime() <= r.inicio.getTime() && r.fin.getTime() <= contenedor.fin.getTime());
}
export function duracionMin(r) {
    return (r.fin.getTime() - r.inicio.getTime()) / 60_000;
}
export function correr(r, minutos) {
    return {
        inicio: new Date(r.inicio.getTime() + minutos * 60_000),
        fin: new Date(r.fin.getTime() + minutos * 60_000),
    };
}
/** Extiende el fin del rango. Usado para materializar el buffer del espacio (§3.6). */
export function extenderFin(r, minutos) {
    return { inicio: r.inicio, fin: new Date(r.fin.getTime() + minutos * 60_000) };
}
//# sourceMappingURL=rango.js.map